import RunReport from "./RunReport"


export const tableColumns = [    
    {
      name: "Service",
      selector: (row) => row.ProName,
      sortable: false,   
    },        
    {
      name: "Total Hours",
      selector: (row) => row.no_of_hours?.toFixed(2),
      sortable: false,
    },
    {
      name: "Total Revenue",
      selector: (row) => '£'+row.total_revenue?.toFixed(2),
      sortable: false,
    },
  ];

const RevenueByServiceType = () => {    
  return (
    <>
    <RunReport ReportID={2} tableColumns={tableColumns} reportName={"Revenue By Service Type"}  />
    </>
  )
}

export default RevenueByServiceType